<template>
    <div class="individual">
        <div class="individual-box">
            <div class="individual-tit">
                <span class="individual-tit-line"></span>
                <span class="individual-tit-bold">个人资料</span>
            </div>

            <div class="individual-info">
                <div class="info-img">
                    <span class="individual-span">当前头像:</span>

                    <div class="upImgBox">
                        <el-upload
                                class="avatar-uploader"
                                :action="uploadAction"
                                :headers="headers"
                                :show-file-list="false"
                                :on-success="morenTouxiangUpload"
                                :before-upload="beforeMorenTouxiangUpload">
                            <img :src="headUrl ? headUrl : headUrlMoren" class="avatar" alt="">
                        </el-upload>
                    </div>
                </div>
                <div class="info-username">
                    <span class="individual-span">用户名:</span>
                    <span class="individual-name">{{ phone }}</span>
                    <span class="individual-explain">用于登录的手机号，修改请前往绑定中换绑</span>
                </div>
                <div class="info-nicheng">
                    <span class="individual-span">昵称:</span>
                    <el-input class="info-nicheng-input" placeholder="请输入内容" :value="username"
                              v-model="username"></el-input>
                </div>
                <div class="info-sex">
                    <span class="individual-span">性别:</span>
                    <el-radio-group v-model="sex" @change="sexChange">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                </div>
                <div class="info-brithday">
                    <span class="individual-span">生日:</span>
                    <el-date-picker
                            class="date-wt"
                            v-model="brithday"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </div>
                <div class="info-btn">
                    <span class="individual-span"></span>
                    <span class="info-btn-submit" @click="keepBtn">保存</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "individual",
        data() {
            return {
                uploadAction: 'http://api2.baostart.com/api/uploadFile', //图片上传接口
                headers: { //图片上传传递请求头
                    Authorization: this.$store.state.userToken
                },
                sex: '',
                brithday: '',
                headUrl: '',
                headUrlMoren: require('@/assets/images/persondata/morentouxiang.png'),
                phone: '',
                username: '',
            }
        },
        methods: {
            // 默认头像--上传图片
            morenTouxiangUpload(res, file) {
                if (res.status == '200') {
                    this.headUrl = res.data;
                }
            },
            // 默认头像--上传图片
            beforeMorenTouxiangUpload(file) {
                const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/webp' || 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('图片格式不正确!(只能包含jpg，png，webp，JPEG)');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },

            sexChange(idx) {
                this.sex = idx;
            },
            myBaseInfo() {
                this.$axios.get("/myBaseInfo").then((res) => {
                    // console.log(res);
                    res = res.data;
                    if (res.status == 200) {
                        this.username = res.data.name;
                        this.phone = res.data.phone;
                        this.headUrl = res.data.headUrl;
                        this.brithday = res.data.birth_day;
                        this.sex = res.data.sex;
                    } else {
                        // layer.msg(res.msg, {icon: 2});
                        this.$message(res.msg);
                    }//请求成功返回的数据
                })
            },
            /*保存按钮*/
            keepBtn() {
                var username = this.username;
                var sex = this.sex;
                var birth_day = this.brithday;
                var headUrl = this.headUrl;
                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                this.$axios.post("/updateUserInfoPc", {
                    name: username,
                    sex,
                    birth_day,
                    headUrl
                }).then((res) => {
                    // layer.closeAll();
                    res = res.data;
                    // console.log(res);
                    if (res.status == 200) {
                        // layer.msg('修改成功', {icon: 1});
                        this.$message('修改成功');
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }
                }).catch((error) => {
                    /*layer.closeAll();
                    layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误');
                });
            },
            /**/
        },
        mounted() {
            this.myBaseInfo();
        },
    }
</script>

<style scoped>
    .individual {
        width: 998px;
        border: 1px solid #EEEEEE;
    }

    .individual-box {
        width: 958px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }

    .individual-tit {
        height: 49px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-tit-line {
        width: 2px;
        height: 14px;
        background: #FF5227;
    }

    .individual-tit-bold {
        margin-left: 10px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .individual-info {
        width: 700px;
        margin-top: 30px;
        margin-bottom: 50px;
    }

    .info-img {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-span {
        width: 70px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: right;
        margin-right: 20px;
    }

    .info-img img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }

    .info-username {
        margin-top: 36px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-name {
        margin-left: 6px;
        margin-right: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .individual-explain {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .info-nicheng {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .info-nicheng-input {
        width: 300px;
    }

    .info-sex {
        margin-top: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .info-brithday {
        margin-top: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .date-wt {
        width: 300px;
    }

    .info-btn {
        margin-top: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .info-btn-submit {
        width: 200px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: #FF5227;
        border-radius: 2px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/individual.vue